import redline from '@/assets/redline.png';

interface IconProps {
  width?: string;
  height?: string;
  className?: string;
  alt?: string;
}

function Redline({
  width = '200',
  height = '70',
  className = '',
  alt = 'Redline',
}: IconProps) {
  return (
    <img
      src={redline}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  );
}

export default Redline;
